import React from 'react'
import PropTypes from 'prop-types'
import { Link, graphql } from 'gatsby'
import { useBreakpoint } from 'gatsby-plugin-breakpoints'

import Layout from '../components/Layout'
import Features from '../components/Features'
import BlogRoll from '../components/BlogRoll'
import CallToAction from '../components/CallToAction'
import RequestCall from '../components/RequestCall'
import Locations from '../components/Locations'
import Cognito from '../components/Cognito'
import Offer from '../components/Offer'
import Hero from '../components/Hero'
import SuperHero from '../components/SuperHero'

export const IndexPageTemplate = ({
  image,
  title,
  heading,
  subheading,
  mainpitch,
  description,
  intro,
  bps,
}) => (
  <>
    {bps.md ? <Hero image={image} subheading={subheading} title={title}/> : <SuperHero image={image} subheading={subheading} title={title}/>}
   
    <Offer title="Limited Time Offer - 20% off our Pest Control Program" tag="Each Application Effective For Up To 3 Months - New Customers - Homes Up To 3000 sq. ft." price=""/>
    <CallToAction />
    <section className="section section--gradient">
      <div className="container is-fluid">
        
        <div className="section">
          <div className="columns">
            <div className="column is-16 is-offset-1">
              <div className="content">
                <div className="content">
                  <div className="tile">
                    <h1 className="title">{mainpitch.title}</h1>
                  </div>
                  <div className="tile">
                    <h3 className="subtitle">{mainpitch.description}</h3>
                  </div>
                </div>
                <div className="columns">
                  <div className="column is-12">
                    <h3 className="has-text-weight-semibold is-size-2">
                      {heading}
                    </h3>
                    <p>{description}</p>
                  </div>
                </div>
                
                <Features gridItems={intro.blurbs} />
                <div className="columns">
                  <div className="column is-12 has-text-centered">
                    <Link className="btn" to="/services">
                      See all services
                    </Link>
                  </div>
                </div>
                <Locations />
                <RequestCall />
                <Cognito />
                <div className="column is-12">
                  <h3 className="has-text-weight-semibold is-size-2">
                   Articles About Controlling Spiders And Pests 
                  </h3>
                  <BlogRoll />
                  <div className="column is-12 has-text-centered">
                    <Link className="btn" to="/blog">
                      Read more
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </>
)

IndexPageTemplate.propTypes = {
  image: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  title: PropTypes.string,
  heading: PropTypes.string,
  subheading: PropTypes.string,
  mainpitch: PropTypes.object,
  description: PropTypes.string,
  intro: PropTypes.shape({
    blurbs: PropTypes.array,
  }),
}

const IndexPage = ({ data }) => {
  
  const breakpoints = useBreakpoint()
  const { frontmatter } = data.markdownRemark

  return (
    <Layout>
      <IndexPageTemplate
        image={frontmatter.image}
        title={frontmatter.title}
        heading={frontmatter.heading}
        subheading={frontmatter.subheading}
        mainpitch={frontmatter.mainpitch}
        description={frontmatter.description}
        intro={frontmatter.intro}
        bps={breakpoints}
      />
    </Layout>
  )
}

IndexPage.propTypes = {
  data: PropTypes.shape({
    markdownRemark: PropTypes.shape({
      frontmatter: PropTypes.object,
    }),
  }),
}

export default IndexPage

export const pageQuery = graphql`
  query IndexPageTemplate {
    markdownRemark(frontmatter: { templateKey: { eq: "index-page" } }) {
      frontmatter {
        title
        image {
          childImageSharp {
            fluid(maxWidth: 2048, quality: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        heading
        subheading
        mainpitch {
          title
          description
        }
        description
        intro {
          blurbs {
            image {
              childImageSharp {
                fluid(maxWidth: 240, quality: 64) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
            servicetitle
            servicetagline
            svcurl
            text
          }
          heading
          description
        }
      }
    }
  }
`
